import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import PriceChangeContainer from "@/screens/Pricing/containers/PriceChangeContainer"
import { priceChangeSearchSchema } from "@/screens/Pricing/types/searchParams"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const Route = createFileRoute("/app/pricing/_layout/price-change")({
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.PRICING_VIEW,
        PermissionActionType.PRICING_MANAGER,
        PermissionActionType.PRICING_MAINTENANCE,
      ]}
    >
      <PriceChangeContainer />
    </PermissionContentWrapper>
  ),

  validateSearch: zodValidator(priceChangeSearchSchema),
  loader: async (): Promise<void> => {
    await useUnitOfMeasurementsStore.getState().getUnits()
  },
})
